import { useQuery } from '@tanstack/react-query';
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import api from '../services/authService';

export const useVendorPayments = (statusFilter = 'all', page = 1, perPage = 15) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['vendorPayments', statusFilter, page, perPage],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (statusFilter !== 'all') {
        params.append('status', statusFilter);
      }
      params.append('page', page);
      params.append('per_page', perPage);
      const response = await api.get(`/vendor/payments?${params.toString()}`);
      return response.data;
    }
  });

  // Handle paginated response structure
  const payments = data?.data?.data || data?.data || [];
  const pagination = data?.data?.current_page ? {
    current_page: data.data.current_page,
    last_page: data.data.last_page,
    per_page: data.data.per_page,
    total: data.data.total,
    from: data.data.from,
    to: data.data.to
  } : null;

  // Helper function to safely format currency amounts
  const formatAmount = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(numAmount) || !isFinite(numAmount)) return '0.00';
    return numAmount.toFixed(2);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return <CheckCircle className="w-4 h-4 text-green-500" />;
      case 'pending':
        return <Clock className="w-4 h-4 text-yellow-500" />;
      case 'failed':
        return <XCircle className="w-4 h-4 text-red-500" />;
      default:
        return <Clock className="w-4 h-4 text-gray-400" />;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'failed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return {
    payments,
    isLoading,
    error,
    pagination,
    formatAmount,
    getStatusIcon,
    getStatusColor
  };
};

